import React from "react";
import Header from "src/components/common/Header";
import Sidebar from "src/components/common/Sidebar";
import Footer from "src/components/common/Footer";
import CandidateAdvancedMain from "src/components/candidate-advanced-search/CandidateAdvancedMain";
import { RODEO_PAGE_NAME } from "src/_config/site_statics";

const CandidateAdvancedSearch: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.CANDIDATE_ADVANCED_SEARCH} />
      <CandidateAdvancedMain />
      <Footer variant="dashboard" />
    </>
  );
};

export default CandidateAdvancedSearch;
